import { useContext } from 'react';

import { RouterPromptContext } from 'components/@main/RouterPrompt';

export default () => useContext(RouterPromptContext);
